"use client";
import { Box } from "@ecco/ui/box";
import { styles } from "./EccoClubCardsStyles";
import { Text } from "@ecco/ui/text";
import { GradientWithGrain } from "../ribbon";
import Barcode from "react-barcode";
import { useGetMyProfile } from "@store/hooks";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { CommonCMS } from "@lib/constants/contentful";

export default function EccoPassCard() {
    const { data: customer } = useGetMyProfile();

    const { getMultiple } = useMicrocopy();

    const microcopies = (() => {
        return getMultiple(CommonCMS.shared, [
            CommonCMS.loyalty.eccoPass,
            CommonCMS.loyalty.membershipId,
            CommonCMS.loyalty.showEccoPass,
        ]);
    })();

    return (
        <Box style={styles.eccoPassContainer}>
            <GradientWithGrain width="100%" height="24px" />
            <Box style={styles.eccoPassContent}>
                <Text fontSize={"sm"}>{microcopies[CommonCMS.loyalty.eccoPass]}</Text>
                <Text
                    textAlign={"center"}
                    fontSize={"lg"}
                    fontWeight="bold"
                    mt={2}
                    wordBreak="break-word"
                >
                    {customer?.firstName} {customer?.lastName}
                </Text>
                <Box style={styles.barCodeContainer}>
                    <Barcode value={customer.loyalty?.cardNumber} displayValue={false} />
                </Box>
                <Text fontSize={"sm"} textAlign={"center"}>
                    {microcopies[CommonCMS.loyalty.membershipId]}
                </Text>
                <Text fontSize={"sm"} textAlign={"center"} mt={1} fontWeight={"bold"}>
                    {customer.loyalty?.cardNumber}
                </Text>
                <Text textAlign={"center"} mt={10}>
                    {microcopies[CommonCMS.loyalty.showEccoPass]}
                </Text>
            </Box>
        </Box>
    );
}
